import { Spinner } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiSensedia } from '../../../../../services/api-sensedia';
import { BackgroundDisabledCardFunds } from '../components/BackgroundDisabledCardFunds';
import { CardFunds } from '../components/CardFunds';
import { MovimentacaoFundosActions } from '../contexts/MovimentacaoFundosContext';
import { useMovimentacaoFundos } from '../hooks/useMovimentacaoFundos';
import { LayoutMovimentacaoFundos } from '../layouts/LayoutMovimentacaoFundos';
import { DataPrevFundType } from '../types/MovimentacaoFundosType';

export const AnaliticoProposta = () => {
  const navigate = useNavigate();
  const { state, setState } = useMovimentacaoFundos();

  const [listFundos, setListFundos] = useState<DataPrevFundType[]>([]);

  let apiMf = apiSensedia;

  if (process.env.NODE_ENV != 'development') {
    apiMf = apiSensedia;
  }

  const getData = async () => {
    let looping = true;
    while (looping) {
      try {
        const res = await apiMf.get(
          `/movimentacoes-fundos/propostas/${state.numero_proposta}/fundos-investimento`,
          {
            headers: {
              cpf: state.cpf,
              'ev-proposta': state.ev
            }
          }
        );

        const fundos = res.data;

        setListFundos([...fundos]);

        looping = false;
      } catch (e: any) {
        if (e.response.status == 500) {
          console.log('ocorreu internal server error', e.response.statusText);
          console.log('ocorreu internal server error', e.response.data);
        } else if (e.response.status == 504) {
          console.log('ocorreu gateway timeout', e.response.data);
        }
        if (e.response.status != 504) {
          looping = false;
        }
      }
    }
  };

  const contentOffer = {
    nome_produto: state.nome_produto,
    numero_proposta: state.numero_proposta,
    nome_cliente: state.nome_cliente,
    valor_proposta: state.valor_saldo ? state.valor_saldo : 15000
  };

  const handleSelectFund = (fund: DataPrevFundType) => {
    setState({
      type: MovimentacaoFundosActions.setIdFundoOrigem,
      payload: fund.id_fundo
    });
    setState({
      type: MovimentacaoFundosActions.setSaldoInicial,
      payload: fund.saldo_fundo
    });
    setState({
      type: MovimentacaoFundosActions.setNomeFundo,
      payload: fund.nome_fundo
    });
    navigate(
      `/corretor/previdencia-individual/movimentacao-fundos/transferindo-percentuais`,
      {
        replace: true
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    console.log('fundos cliente', listFundos);
  }, [listFundos]);

  return (
    <LayoutMovimentacaoFundos
      navigate={() => {
        navigate(
          '/corretor/previdencia-individual/movimentacao-fundos/base-clientes'
        );
      }}
      offerContent={contentOffer}
    >
      <div className="tw-relative tw-scrollbar-customized tw-w-full tw-max-w-6xl tw-p-5 tw-bg-white tw-rounded-lg tw-shadow-md tw-mb-5 tw-overflow-y-auto tw-max-h-[1050px]">
        <h2 className="tw-text-lg tw-font-semibold tw-text-blue-900">Fundos</h2>
        {listFundos.length <= 0 ? (
          <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-[300px]">
            <Spinner color="#1C375C" size="xl" />
          </div>
        ) : (
          <div className="tw-grid tw-grid-cols-3 tw-gap-x-4 tw-gap-y-6 ">
            {listFundos?.map((fund: DataPrevFundType, cont: number) => {
              return (
                <BackgroundDisabledCardFunds
                  key={cont}
                  isDisabled={!fund.available}
                >
                  <CardFunds
                    dataCardFund={fund}
                    handleSelectFund={handleSelectFund}
                  />
                </BackgroundDisabledCardFunds>
              );
            })}
          </div>
        )}
      </div>
    </LayoutMovimentacaoFundos>
  );
};
